export default "/images/tvcom-icon.webp?e05f730ecdc86d48b57e98af0e400b24";